import type { NativeSelectOption } from '@shared/ui/fields'

import { useDisciplineScheduleStore } from './schedule/store'
import { useDisciplineScheduleContext } from './discipline-schedule-context.hook'
import { getSchedulePaceOptions } from './discipline-schedule'

interface ModalDisciplineSchedulePaceReturn {
  refOptions: ComputedRef<NativeSelectOption[]>
  refValue: ComputedRef<number>
  refIsEditable: ComputedRef<boolean>
  refHasWarning: ComputedRef<boolean>
  refIsDisabled: ComputedRef<boolean>
  setPace: (option: NativeSelectOption) => void
  close: () => void
  back: () => void
  confirm: () => void
}

/** A discipline with a pace keeps it; one without must get one before a tutor can be searched for. */
export const useModalDisciplineSchedulePace = (): ModalDisciplineSchedulePaceReturn => {
  const store = useDisciplineScheduleStore()
  const { refDetails, close, back } = useDisciplineScheduleContext()

  const refDisciplinePace = computed<number>(() => refDetails.value?.pace ?? 0)

  const refValue = computed<number>(() => refDisciplinePace.value || store.getPace || 0)
  const refOptions = computed<NativeSelectOption[]>(() => getSchedulePaceOptions(refValue.value))
  const refIsEditable = computed<boolean>(() => !refDisciplinePace.value)
  const refHasWarning = computed<boolean>(() => refIsEditable.value && !store.getPace)
  const refIsDisabled = computed<boolean>(() => !refDisciplinePace.value && !store.getPace)

  const setPace = (option: NativeSelectOption): void => {
    const pace = Number(option.value)
    if (pace) store.setPace(pace)
  }

  return {
    refOptions,
    refValue,
    refIsEditable,
    refHasWarning,
    refIsDisabled,
    setPace,
    close,
    back,
    confirm: () => store.nextStep(),
  }
}
